import { MainMenuItemsProps } from "../MainMenuItem/props";

export type MenuItemSubItem = {
  label: string;
  path: string;
};

export type MenuItem = {
  label: string;
  icon: string;
  path: string;
  cy: string;
  subItems: MenuItemSubItem[];
};

export const DASHBOARD: MenuItem = {
  label: "Dashboard",
  icon: "house",
  path: "/dashboard",
  cy: "sidebar-dashboard",
  subItems: [],
};

export const SETTINGS: MenuItem = {
  label: "Settings",
  icon: "gear",
  path: "/settings",
  cy: "sidebar-settings",
  subItems: [],
};

export const DOCUMENTS: MenuItem = {
  label: "Documents",
  icon: "file-lines",
  path: "/documents",
  cy: "sidebar-documents",
  subItems: [],
};

export const MESSAGES: MenuItem = {
  label: "Messages",
  icon: "envelope",
  path: "/messages",
  cy: "sidebar-messages",
  subItems: [],
};

export const LOANS: MenuItem = {
  label: "Loans",
  icon: "file-pen",
  path: "/loans",
  cy: "sidebar-loans",
  subItems: [],
};

export const PROPERTY: MenuItem = {
  label: "Properties",
  icon: "building",
  path: "/properties",
  cy: "sidebar-properties",
  subItems: [],
};

export const ANALYTICS: MenuItem = {
  label: "Analytics",
  icon: "chart-pie",
  path: "/analytics",
  cy: "sidebar-analytics",
  subItems: [
    {
      label: "Revenue",
      path: "/analytics/revenue",
    },
  ],
};

export const TRANSACTIONS: MenuItem = {
  label: "Transactions",
  icon: "money-bill",
  path: "/transactions",
  cy: "sidebar-transactions",
  subItems: [
    {
      label: "Payments",
      path: "/transactions/payments",
    },
    {
      label: "Draws",
      path: "/transactions/draws",
    },
    {
      label: "Fees",
      path: "/transactions/fees",
    },
    {
      label: "Statements",
      path: "/transactions/statements",
    },
  ],
};

export const BORROWERS: MenuItem = {
  label: "Borrowers",
  icon: "users",
  path: "/borrowers",
  cy: "sidebar-borrowers",
  subItems: [],
};

export const DEFAULT_ITEMS = {
  lender: [
    DASHBOARD,
    LOANS,
    BORROWERS,
    TRANSACTIONS,
    DOCUMENTS,
    PROPERTY,
    MESSAGES,
    ANALYTICS,
    SETTINGS,
  ],
  borrower: [DASHBOARD, LOANS, PROPERTY, DOCUMENTS, MESSAGES, SETTINGS],
};
